import { derived, writable } from 'svelte/store';
import 'unfetch/polyfill';


export const availabilityEnablesDatesData = writable({});

export const availabilityEnableDatesForCalendar = derived(
  [availabilityEnablesDatesData],
  ([$availabilityEnablesDatesData]) => $availabilityEnablesDatesData.Dates
);
export const lastCheckoutDatesForCalendar = derived(
  [availabilityEnablesDatesData],
  ([$availabilityEnablesDatesData]) => $availabilityEnablesDatesData.LastCheckoutDates
);

export const availabilityEnableDateStatus = derived(
  [availabilityEnablesDatesData],
  ([$availabilityEnablesDatesData]) => $availabilityEnablesDatesData.Status
);
export const maxDaysInAdvance = derived(
  [availabilityEnablesDatesData],
  ([$availabilityEnablesDatesData]) => $availabilityEnablesDatesData.MaxDaysInAdvance
);


export const isAllTooManyPeople = derived(
  [availabilityEnablesDatesData],
  ([$availabilityEnablesDatesData]) =>
    $availabilityEnablesDatesData.Status === 'P'
);

export const isAllBooked = derived(
  [availabilityEnablesDatesData],
  ([$availabilityEnablesDatesData]) =>
    $availabilityEnablesDatesData.Status === 'B'
);

export const availabilityEnableDateMessageStatus = derived(
  [availabilityEnablesDatesData, availabilityEnableDateStatus],
  ([$availabilityEnablesDatesData, $availabilityEnableDateStatus]) => {
    if ($availabilityEnableDateStatus === undefined) return;
    return $availabilityEnablesDatesData.DatesMessage;
  }
);

export const isFetchingEnableDates = writable(false);

/**
 * @author Dat Doan
 * @date 2021-03-09
 * @param {string} queryString
 * @returns {object}
 */
export async function getAvailabilityEnableDates(queryString) {
  // Bail when param is not empty
  if (!queryString) {
    return;
  }

  isFetchingEnableDates.set(true);
  const hostname = '//' + location.hostname;
  const endpointPath = '/npws/ReservationApi/AvailabilityDates?';

  try {
    const response = await fetch(hostname + endpointPath + queryString);
    const data = await response.json();
    isFetchingEnableDates.set(false);
    availabilityEnablesDatesData.set(data);
  } catch (error) {
    isFetchingEnableDates.set(false);
    console.warn(`Request "Enable Dates" issue ${error}`);
  }
}
